import type { SVGProps } from "react";
export interface MouthIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MouthIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MouthIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M14.387 4.878c1.04-.055 1.965.282 2.814.807.83.513 1.641 1.243 2.474 2.053.42.41.863.857 1.324 1.322.464.467.951.957 1.475 1.467l.14.15c.617.729.7 1.825.118 2.634l-.135.168c-3.135 3.534-6.378 5.52-10.223 5.64l-.373.006c-3.76 0-6.94-1.756-9.99-4.98l-.607-.666c-.774-.872-.669-2.182.121-2.951L3.001 9.06c.46-.465.903-.912 1.324-1.322.832-.81 1.644-1.54 2.474-2.053.848-.525 1.773-.862 2.814-.807.808.042 1.594.317 2.386.783.792-.466 1.58-.741 2.388-.783m.117 2.247c-.462.024-1.052.22-1.85.79-.391.28-.917.28-1.308 0-.799-.57-1.388-.766-1.85-.79-.451-.024-.924.109-1.512.473-.607.376-1.273.957-2.089 1.752-.404.393-.83.823-1.296 1.293q-.666.674-1.436 1.427c2.967 3.316 5.733 4.805 8.838 4.805l.583-.018c2.87-.177 5.473-1.68 8.253-4.787-.514-.5-.992-.98-1.436-1.427-.466-.47-.892-.9-1.295-1.293-.817-.795-1.482-1.376-2.089-1.752-.589-.365-1.062-.497-1.513-.473"
      />
      <path
        fill={color}
        d="m17 10.875.115.006a1.125 1.125 0 0 1 0 2.238l-.114.006H7a1.125 1.125 0 0 1 0-2.25z"
      />
    </svg>
  );
}
